import { createPortal } from "react-dom";

export const PortalImage = ({ children }) => {

  if (typeof window !== "undefined") {
    return createPortal(
      <div>{children}</div>,
      document.body
    )
  }
  return <></>
}

